var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.11 20.775A41.528 41.528 0 0 1 60 18.4c22.974 0 41.599 18.625 41.599 41.6 0 10.895-4.187 20.81-11.043 28.227a1.7 1.7 0 1 0 2.497 2.308c7.413-8.021 11.946-18.751 11.946-30.536 0-24.852-20.147-44.999-45-44.999a44.93 44.93 0 0 0-15.024 2.57 1.7 1.7 0 0 0 1.135 3.205Zm-14.338 8.668a1.7 1.7 0 0 0-2.308-2.497C20.572 35.164 15 46.932 15 59.999c0 24.853 20.147 45 45 45 6.74 0 13.14-1.484 18.885-4.143a1.7 1.7 0 0 0-1.429-3.086A41.437 41.437 0 0 1 60 101.6c-22.974 0-41.599-18.625-41.599-41.6 0-12.08 5.147-22.954 13.372-30.556Zm46.837 18.674a1.7 1.7 0 1 0-2.579-2.215l-21.089 24.55L43.914 58.83a1.7 1.7 0 0 0-2.467 2.34l12.324 12.99a1.7 1.7 0 0 0 2.523-.062l22.316-25.98Z",
    fill: "#3489F3"
  })));
};

export default SvgSuccess;